import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ReviewQR from "@/pages/admin/ReviewQR";
import BagQR from "@/pages/admin/BagQR";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/cookie" element={<LegalPage kind="cookie" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/qr-recensioni"
              element={
                <ProtectedRoute>
                  <ReviewQR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/qr-sacchetti"
              element={
                <ProtectedRoute>
                  <BagQR />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
